import { createZodDto } from 'nestjs-zod/dto';
import { z } from 'zod';
export const GuestLinkWorkspaceLoginSchema = z.object({
    workspaceId: z.string(),
    linkId: z.string(),
});
export class GuestLinkWorkspaceLoginDto extends createZodDto(GuestLinkWorkspaceLoginSchema) {
}
